import logger from './logger';

export class LocalStorage {
  data = {};
  defaultKey = 'cloud-batch';

  constructor(mainKey) {
    this.mainKey = mainKey || this.defaultKey;
    this.load();
  }

  load() {
    if (!window.localStorage) {
      return;
    }

    try {
      this.data = JSON.parse(window.localStorage.getItem(this.mainKey)) || {};
    } catch (e) {
      logger.error(e);
      logger.warn('Issue loading data from local storage', this.mainKey);
      this.data = {};
    }
  }

  save() {
    if (!window.localStorage) {
      return;
    }

    try {
      window.localStorage.setItem(this.mainKey, JSON.stringify(this.data));
    } catch (e) {
      logger.error(e);
      logger.warn('Issue saving data to local storage', this.mainKey);
    }
  }

  getItem(key) {
    return this.data[key];
  }

  setItem(key, value) {
    const item = { [key]: value };
    const itemSize = (JSON.stringify(item).length * 2) / 1024 / 1024;

    if (this.getSize() + itemSize > 8) {
      const oldItem = this.getItem(key);

      if (!oldItem) {
        logger.warn('storage size:', this.getSize(), this.mainKey, `item: ${key}, item size`, itemSize);
        return;
      }

      const oldItemSize = (JSON.stringify(oldItem).length * 2) / 1024 / 1024;

      if (itemSize > oldItemSize + 0.1) {
        logger.warn('storage size:', this.getSize(), this.mainKey, `item: ${key}, item size`, itemSize, 'old size', oldItemSize);
        return;
      }
    }

    Object.assign(this.data, item);

    return this.save();
  }

  getSize() {
    let total = 0;

    for (let x in localStorage) {
      if (localStorage.hasOwnProperty(x)) {
        const amount = (localStorage[x].length * 2) / 1024 / 1024;
        if (!isNaN(amount)) {
          total += amount;
        }
      }
    }

    return parseFloat(total.toFixed(2));
  }

  removeItem(key) {
    delete this.data[key];
    return this.save();
  }
}

const storage = new LocalStorage();
export default storage;
